module.exports = __webpack_public_path__ + "static/media/vault.f7d2398a.png";